import { fetchHardwareVendorHelper } from "./featureChangeApi"

export const solidCurtainFeatureGroup = [
    {
        name: "Location",
        features: [
            {
                slug: 'location',
                name: 'Location',
                type: 'select',
                affectsPrice: true,
                options: [
                    { value: 'IN', label: 'India' },
                    { value: 'GB', label: 'United Kingdom' },
                    { value: 'AE', label: 'UAE' },
                    { value: 'SA', label: 'KSA' },
                ],
                required: true,
                default: 'IN',
                dependencies: [],
            },
        ]
    },
    {
        name: "Quantity",
        features: [
            {
                slug: "pairOrSingle",
                name: "Pair or Single",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "PAIR", label: "Pair", default: false },
                    { value: "SINGLE", label: "Single", default: true }
                ],
                default: "SINGLE",
                dependencies: [],
                onFeatureChange: async (newValue, values, helpers) => {
                    if (newValue === "PAIR") {
                        await helpers?.setValue("orientation", "CENTRE_OPEN")
                    } else {
                        if (values.orientation && values.orientation === "CENTRE_OPEN") {
                            await helpers?.setValue("orientation", "LEFT_TO_RIGHT", false)
                        }
                    }
                }
            },
            {
                slug: "orientation",
                name: "Orientation",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "CENTRE_OPEN", label: "Centre Open" },
                    { value: "LEFT_TO_RIGHT", label: "Left to Right", default: true },
                    { value: "RIGHT_TO_LEFT", label: "Right to Left" }
                ],
                dependencies: [
                    {
                        featureSlug: "pairOrSingle",
                        condition: "PAIR",
                        allowedValues: ["CENTRE_OPEN"]
                    },
                    {
                        featureSlug: "pairOrSingle",
                        condition: "SINGLE",
                        allowedValues: ["LEFT_TO_RIGHT", "RIGHT_TO_LEFT"]
                    }
                ]
            },
            {
                slug: "quantity",
                name: "Quantity",
                type: "number",
                structure: "flat",
                renderType: "quantity",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                default: 1
            }
        ]
    },
    {
        name: "Measurement",
        features: [
            {
                slug: "unit",
                name: "Unit",
                type: "radio",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "cm", label: "Centimeters", default: false },
                    { value: "inch", label: "Inches", default: true }
                ],
                dependencies: []
            },
            {
                slug: "dimensions",
                name: "Width X Height",
                type: "nested",
                structure: "nested",
                renderType: "dimension",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "width",
                        path: "dimensions.width",
                        name: "Width",
                        type: "number",
                        affectsPrice: true,
                        default: 119,
                        required: true
                    },
                    {
                        slug: "height",
                        path: "dimensions.height",
                        name: "Height",
                        type: "number",
                        affectsPrice: true,
                        default: 119,
                        required: true
                    }
                ]
            },
            {
                slug: 'fullness',
                name: 'Curtain Fullness',
                type: 'select',
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: 2, label: '200', default: false },
                    { value: 2.5, label: '250', default: true },
                    { value: 3, label: '300', default: false }
                ],
                dependencies: [],
            },
            {
                slug: "curtainLengthStyle",
                name: "Curtain Length Style",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "FLOAT", label: "Float", default: false },
                    { value: "FLOOR", label: "Floor", default: true },
                    { value: "PUDDLED", label: "Puddled", default: false }
                ],
                dependencies: []
            }
        ]
    },
    {
        name: "Pleat",
        features: [
            {
                slug: "pleat",
                name: "Pleat Style",
                type: "select",
                structure: "flat",
                required: false,
                affectsPrice: true,
                options: [
                    { value: "RIPPLE", label: "Ripple Pleat" },
                    { value: "APL", label: "American Pleat" }
                ],
                dependencies: [],
                default: "RIPPLE",
                onFeatureChange: async (newValue, values, helpers) => {
                    // Refetch hardware vendors when pleat changes
                    await fetchHardwareVendorHelper(values, helpers)
                }
            }
        ]
    },
    {
        name: "Lining",
        features: [
            {
                slug: "liningType",
                name: "Lining Type",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "BLACKOUT", label: "Blackout", priceImpact: "fixed" },
                    { value: "DIMOUT", label: "Dimout", priceImpact: "fixed" },
                    { value: "STANDARD", label: "Standard", priceImpact: "fixed" }
                    // { value: 'NONE', label: 'None', priceImpact: 'fixed' }
                ],
                dependencies: [],
                default: "BLACKOUT"
            },
            {
                slug: "thermalInterlining",
                name: "Thermal Interlining",
                type: "select",
                structure: "flat",
                required: false,
                affectsPrice: true,
                options: [
                    { value: true, label: "Yes", priceImpact: "fixed" },
                    { value: false, label: "No", priceImpact: "fixed" }
                ],
                dependencies: [],
                default: false
            }
        ]
    },
    {
        name: "Mount Type",
        features: [
            {
                slug: "mountType",
                name: "Mount Type",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "WALL", label: "Wall Mount" },
                    { value: "CEILING", label: "Ceiling Mount" }
                ],
                dependencies: [],
                default: "WALL"
            }
        ]
    },
    {
        name: "Hardware",
        features: [
            {
                slug: "hardware",
                name: "Hardware",
                type: "nested",
                structure: "nested",
                // renderType: "HardwareSelector",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "hardwareType",
                        name: "Hardware Type",
                        type: "select",
                        structure: "flat",
                        path: "hardware.hardwareType",
                        options: [
                            { value: "MOTORIZED", label: "Motorized" },
                            { value: "MANUAL", label: "Manual" },
                            { value: "NONE", label: "No Hardware" }
                        ],
                        required: true,
                        default: "NONE",
                        affectsPrice: true,
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue, handleFeatureChange } = helpers

                            try {
                                const updates = []

                                // Clear vendor
                                if (values?.hardware?.vendor) {
                                    updates.push({ path: "hardware.vendor", value: undefined })
                                }

                                // Handle motorized type
                                if (newValue === "MOTORIZED") {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: "HOME_AUTOMATION"
                                    })
                                } else if (
                                    newValue !== "MOTORIZED" &&
                                    values?.hardware?.motorizedType
                                ) {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: undefined
                                    })
                                }

                                // Apply all updates at once
                                if (updates.length > 0) {
                                    await helpers.setValues(updates)
                                }

                                // Fetch vendors after updates
                                await fetchHardwareVendorHelper(
                                    {
                                        ...values,
                                        hardware: { ...values.hardware, hardwareType: newValue }
                                    },
                                    helpers
                                )
                            } catch (error) {
                                console.error("Error in hardware type onChange:", error)
                            }
                        }
                    },
                    {
                        slug: "motorizedType",
                        name: "Motorized Option",
                        type: "select",
                        structure: "flat",
                        path: "hardware.motorizedType",
                        options: [
                            { value: "REMOTE", label: "Remote" },
                            { value: "HOME_AUTOMATION", label: "Home Automation" }
                        ],
                        default: "",
                        required: false,
                        affectsPrice: true,
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ],
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue } = helpers

                            // Clear vendor when motorized type changes
                            if (values?.hardware?.vendor) {
                                await setValue("hardware.vendor", undefined)
                            }
                            console.log("FEtch called in motorizied typeLALALALALLALAALL")

                            // Refetch vendors
                            await fetchHardwareVendorHelper(
                                {
                                    ...values,
                                    hardware: {
                                        hardwareType: "MOTORIZED",
                                        motorizedType: newValue
                                    }
                                },
                                helpers
                            )
                        }
                    },
                    {
                        slug: "vendor",
                        name: "Vendor",
                        type: "select",
                        structure: "flat",
                        path: "hardware.vendor",
                        required: true,
                        affectsPrice: true,
                        options: [],
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MANUAL"
                            },
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

export const sheerCurtainFeatureGroup = [
    {
        name: "Location",
        features: [
            {
                slug: 'location',
                name: 'Location',
                type: 'select',
                affectsPrice: true,
                options: [
                    { value: 'IN', label: 'India' },
                    { value: 'GB', label: 'United Kingdom' },
                    { value: 'AE', label: 'UAE' },
                    { value: 'SA', label: 'KSA' },
                ],
                required: true,
                default: 'IN',
                dependencies: [],
            },
        ]
    },
    {
        name: "Quantity",
        features: [
            {
                slug: "pairOrSingle",
                name: "Pair or Single",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "PAIR", label: "Pair", default: false },
                    { value: "SINGLE", label: "Single", default: true }
                ],
                default: "SINGLE",
                dependencies: [],
                onFeatureChange: async (newValue, values, helpers) => {
                    if (newValue === "PAIR") {
                        await helpers?.setValue("orientation", "CENTRE_OPEN")
                    } else {
                        if (values.orientation && values.orientation === "CENTRE_OPEN") {
                            await helpers?.setValue("orientation", "LEFT_TO_RIGHT", false)
                        }
                    }
                }
            },
            {
                slug: "orientation",
                name: "Orientation",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "CENTRE_OPEN", label: "Centre Open" },
                    { value: "LEFT_TO_RIGHT", label: "Left to Right", default: true },
                    { value: "RIGHT_TO_LEFT", label: "Right to Left" }
                ],
                dependencies: [
                    {
                        featureSlug: "pairOrSingle",
                        condition: "PAIR",
                        allowedValues: ["CENTRE_OPEN"]
                    },
                    {
                        featureSlug: "pairOrSingle",
                        condition: "SINGLE",
                        allowedValues: ["LEFT_TO_RIGHT", "RIGHT_TO_LEFT"]
                    }
                ]
            },
            {
                slug: "quantity",
                name: "Quantity",
                type: "number",
                structure: "flat",
                renderType: "quantity",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                default: 1
            }
        ]
    },
    {
        name: "Measurement",
        features: [
            {
                slug: "unit",
                name: "Unit",
                type: "radio",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "cm", label: "Centimeters", default: false },
                    { value: "inch", label: "Inches", default: true }
                ],
                dependencies: []
            },
            {
                slug: "dimensions",
                name: "Width X Height",
                type: "nested",
                structure: "nested",
                renderType: "dimension",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "width",
                        path: "dimensions.width",
                        name: "Width",
                        type: "number",
                        affectsPrice: true,
                        default: 119,
                        required: true
                    },
                    {
                        slug: "height",
                        path: "dimensions.height",
                        name: "Height",
                        type: "number",
                        affectsPrice: true,
                        default: 119,
                        required: true
                    }
                ]
            },
            {
                slug: 'fullness',
                name: 'Curtain Fullness',
                type: 'select',
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: 2, label: '200', default: false },
                    { value: 2.5, label: '250', default: true },
                    { value: 3, label: '300', default: false }
                ],
                dependencies: [],
            },
            {
                slug: "curtainLengthStyle",
                name: "Curtain Length Style",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "FLOAT", label: "Float", default: false },
                    { value: "FLOOR", label: "Floor", default: true },
                    { value: "PUDDLED", label: "Puddled", default: false }
                ],
                dependencies: []
            }
        ]
    },
    {
        name: "Pleat",
        features: [
            {
                slug: "pleat",
                name: "Pleat Style",
                type: "select",
                structure: "flat",
                required: false,
                affectsPrice: true,
                options: [
                    { value: "RIPPLE", label: "Ripple Pleat" },
                    { value: "APL", label: "American Pleat" }
                ],
                dependencies: [],
                default: "RIPPLE",
                onFeatureChange: async (newValue, values, helpers) => {
                    // Refetch hardware vendors when pleat changes
                    await fetchHardwareVendorHelper(values, helpers)
                }
            }
        ]
    },
    {
        name: "Mount Type",
        features: [
            {
                slug: "mountType",
                name: "Mount Type",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "WALL", label: "Wall Mount" },
                    { value: "CEILING", label: "Ceiling Mount" }
                ],
                dependencies: [],
                default: "WALL"
            }
        ]
    },
    {
        name: "Hardware",
        features: [
            {
                slug: "hardware",
                name: "Hardware",
                type: "nested",
                structure: "nested",
                // renderType: "HardwareSelector",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "hardwareType",
                        name: "Hardware Type",
                        type: "select",
                        structure: "flat",
                        path: "hardware.hardwareType",
                        options: [
                            { value: "MOTORIZED", label: "Motorized" },
                            { value: "MANUAL", label: "Manual" },
                            { value: "NONE", label: "No Hardware" }
                        ],
                        required: true,
                        default: "NONE",
                        affectsPrice: true,
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue, handleFeatureChange } = helpers

                            try {
                                const updates = []

                                // Clear vendor
                                if (values?.hardware?.vendor) {
                                    updates.push({ path: "hardware.vendor", value: undefined })
                                }

                                // Handle motorized type
                                if (newValue === "MOTORIZED") {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: "HOME_AUTOMATION"
                                    })
                                } else if (
                                    newValue !== "MOTORIZED" &&
                                    values?.hardware?.motorizedType
                                ) {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: undefined
                                    })
                                }

                                // Apply all updates at once
                                if (updates.length > 0) {
                                    await helpers.setValues(updates)
                                }

                                // Fetch vendors after updates
                                await fetchHardwareVendorHelper(
                                    {
                                        ...values,
                                        hardware: { ...values.hardware, hardwareType: newValue }
                                    },
                                    helpers
                                )
                            } catch (error) {
                                console.error("Error in hardware type onChange:", error)
                            }
                        }
                    },
                    {
                        slug: "motorizedType",
                        name: "Motorized Option",
                        type: "select",
                        structure: "flat",
                        path: "hardware.motorizedType",
                        options: [
                            { value: "REMOTE", label: "Remote" },
                            { value: "HOME_AUTOMATION", label: "Home Automation" }
                        ],
                        default: "",
                        required: false,
                        affectsPrice: true,
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ],
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue } = helpers

                            // Clear vendor when motorized type changes
                            if (values?.hardware?.vendor) {
                                await setValue("hardware.vendor", undefined)
                            }
                            console.log("FEtch called in motorizied typeLALALALALLALAALL")

                            // Refetch vendors
                            await fetchHardwareVendorHelper(
                                {
                                    ...values,
                                    hardware: {
                                        hardwareType: "MOTORIZED",
                                        motorizedType: newValue
                                    }
                                },
                                helpers
                            )
                        }
                    },
                    {
                        slug: "vendor",
                        name: "Vendor",
                        type: "select",
                        structure: "flat",
                        path: "hardware.vendor",
                        required: true,
                        affectsPrice: true,
                        options: [],
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MANUAL"
                            },
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

export const solidRomanBlindFeatureGroups = [
    {
        name: "Location",
        features: [
            {
                slug: 'location',
                name: 'Location',
                type: 'select',
                affectsPrice: true,
                options: [
                    { value: 'IN', label: 'India' },
                    { value: 'GB', label: 'United Kingdom' },
                    { value: 'AE', label: 'UAE' },
                    { value: 'SA', label: 'KSA' },
                ],
                required: true,
                default: 'IN',
                dependencies: [],
            },
        ]
    },
    {
        name: "Quantity",
        features: [
            {
                slug: "quantity",
                name: "Quantity",
                type: "number",
                structure: "flat",
                renderType: "quantity",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                default: 1
            }
        ]
    },
    {
        name: "Measurement",
        features: [
            {
                slug: "unit",
                name: "Unit",
                type: "radio",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "cm", label: "Centimeters", default: false },
                    { value: "inch", label: "Inches", default: true }
                ],
                dependencies: []
            },
            {
                slug: "dimensions",
                name: "Width X Height",
                type: "nested",
                structure: "nested",
                renderType: "dimension",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "width",
                        path: "dimensions.width",
                        name: "Width",
                        type: "number",
                        affectsPrice: true,
                        default: 80,
                        required: true
                    },
                    {
                        slug: "height",
                        path: "dimensions.height",
                        name: "Height",
                        type: "number",
                        affectsPrice: true,
                        default: 80,
                        required: true
                    }
                ]
            }
        ]
    },
    {
        name: "Lining",
        features: [
            {
                slug: "liningType",
                name: "Lining Type",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "BLACKOUT", label: "Blackout", priceImpact: "fixed" },
                    { value: "DIMOUT", label: "Dimout", priceImpact: "fixed" },
                    { value: "STANDARD", label: "Standard", priceImpact: "fixed" }
                    // { value: 'NONE', label: 'None', priceImpact: 'fixed' }
                ],
                dependencies: [],
                default: "BLACKOUT"
            },
            {
                slug: "thermalInterlining",
                name: "Thermal Interlining",
                type: "select",
                structure: "flat",
                required: false,
                affectsPrice: true,
                options: [
                    { value: true, label: "Yes", priceImpact: "fixed" },
                    { value: false, label: "No", priceImpact: "fixed" }
                ],
                dependencies: [],
                default: false
            }
        ]
    },
    {
        name: "Mount Type",
        features: [
            {
                slug: "mountType",
                name: "Mount Type",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "WALL", label: "Wall Mount" },
                    { value: "CEILING", label: "Ceiling Mount" }
                ],
                dependencies: [],
                default: "WALL"
            }
        ]
    },
    {
        name: "Hardware",
        features: [
            {
                slug: "hardware",
                name: "Hardware",
                type: "nested",
                structure: "nested",
                // renderType: "HardwareSelector",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "hardwareType",
                        name: "Hardware Type",
                        type: "select",
                        structure: "flat",
                        path: "hardware.hardwareType",
                        options: [
                            { value: "MOTORIZED", label: "Motorized" },
                            { value: "MANUAL", label: "Manual" },
                            { value: "NONE", label: "No Hardware" }
                        ],
                        required: true,
                        default: "NONE",
                        affectsPrice: true,
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue, handleFeatureChange } = helpers

                            try {
                                const updates = []

                                // Clear vendor
                                if (values?.hardware?.vendor) {
                                    updates.push({ path: "hardware.vendor", value: undefined })
                                }

                                // Handle motorized type
                                if (newValue === "MOTORIZED") {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: "HOME_AUTOMATION"
                                    })
                                } else if (
                                    newValue !== "MOTORIZED" &&
                                    values?.hardware?.motorizedType
                                ) {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: undefined
                                    })
                                }

                                // Apply all updates at once
                                if (updates.length > 0) {
                                    await helpers.setValues(updates)
                                }

                                // Fetch vendors after updates
                                await fetchHardwareVendorHelper(
                                    {
                                        ...values,
                                        hardware: { ...values.hardware, hardwareType: newValue }
                                    },
                                    helpers
                                )
                            } catch (error) {
                                console.error("Error in hardware type onChange:", error)
                            }
                        }
                    },
                    {
                        slug: "motorizedType",
                        name: "Motorized Option",
                        type: "select",
                        structure: "flat",
                        path: "hardware.motorizedType",
                        options: [
                            { value: "REMOTE", label: "Remote" },
                            { value: "HOME_AUTOMATION", label: "Home Automation" }
                        ],
                        default: "",
                        required: false,
                        affectsPrice: true,
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ],
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue } = helpers

                            // Clear vendor when motorized type changes
                            if (values?.hardware?.vendor) {
                                await setValue("hardware.vendor", undefined)
                            }
                            console.log("FEtch called in motorizied typeLALALALALLALAALL")

                            // Refetch vendors
                            await fetchHardwareVendorHelper(
                                {
                                    ...values,
                                    hardware: {
                                        hardwareType: "MOTORIZED",
                                        motorizedType: newValue
                                    }
                                },
                                helpers
                            )
                        }
                    },
                    {
                        slug: "vendor",
                        name: "Vendor",
                        type: "select",
                        structure: "flat",
                        path: "hardware.vendor",
                        required: true,
                        affectsPrice: true,
                        options: [],
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MANUAL"
                            },
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

export const sheerRomanBlindFeatureGroups = [
    {
        name: "Location",
        features: [
            {
                slug: 'location',
                name: 'Location',
                type: 'select',
                affectsPrice: true,
                options: [
                    { value: 'IN', label: 'India' },
                    { value: 'GB', label: 'United Kingdom' },
                    { value: 'AE', label: 'UAE' },
                    { value: 'SA', label: 'KSA' },
                ],
                required: true,
                default: 'IN',
                dependencies: [],
            },
        ]
    },
    {
        name: "Quantity",
        features: [
            {
                slug: "quantity",
                name: "Quantity",
                type: "number",
                structure: "flat",
                renderType: "quantity",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                default: 1
            }
        ]
    },
    {
        name: "Measurement",
        features: [
            {
                slug: "unit",
                name: "Unit",
                type: "radio",
                structure: "flat",
                required: true,
                affectsPrice: true,
                options: [
                    { value: "cm", label: "Centimeters", default: false },
                    { value: "inch", label: "Inches", default: true }
                ],
                dependencies: []
            },
            {
                slug: "dimensions",
                name: "Width X Height",
                type: "nested",
                structure: "nested",
                renderType: "dimension",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "width",
                        path: "dimensions.width",
                        name: "Width",
                        type: "number",
                        affectsPrice: true,
                        default: 80,
                        required: true
                    },
                    {
                        slug: "height",
                        path: "dimensions.height",
                        name: "Height",
                        type: "number",
                        affectsPrice: true,
                        default: 80,
                        required: true
                    }
                ]
            }
        ]
    },
    {
        name: "Mount Type",
        features: [
            {
                slug: "mountType",
                name: "Mount Type",
                type: "select",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "WALL", label: "Wall Mount" },
                    { value: "CEILING", label: "Ceiling Mount" }
                ],
                dependencies: [],
                default: "WALL"
            }
        ]
    },
    {
        name: "Hardware",
        features: [
            {
                slug: "hardware",
                name: "Hardware",
                type: "nested",
                structure: "nested",
                // renderType: "HardwareSelector",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "hardwareType",
                        name: "Hardware Type",
                        type: "select",
                        structure: "flat",
                        path: "hardware.hardwareType",
                        options: [
                            { value: "MOTORIZED", label: "Motorized" },
                            { value: "MANUAL", label: "Manual" },
                            { value: "NONE", label: "No Hardware" }
                        ],
                        required: true,
                        default: "NONE",
                        affectsPrice: true,
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue, handleFeatureChange } = helpers

                            try {
                                const updates = []

                                // Clear vendor
                                if (values?.hardware?.vendor) {
                                    updates.push({ path: "hardware.vendor", value: undefined })
                                }

                                // Handle motorized type
                                if (newValue === "MOTORIZED") {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: "HOME_AUTOMATION"
                                    })
                                } else if (
                                    newValue !== "MOTORIZED" &&
                                    values?.hardware?.motorizedType
                                ) {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: undefined
                                    })
                                }

                                // Apply all updates at once
                                if (updates.length > 0) {
                                    await helpers.setValues(updates)
                                }

                                // Fetch vendors after updates
                                await fetchHardwareVendorHelper(
                                    {
                                        ...values,
                                        hardware: { ...values.hardware, hardwareType: newValue }
                                    },
                                    helpers
                                )
                            } catch (error) {
                                console.error("Error in hardware type onChange:", error)
                            }
                        }
                    },
                    {
                        slug: "motorizedType",
                        name: "Motorized Option",
                        type: "select",
                        structure: "flat",
                        path: "hardware.motorizedType",
                        options: [
                            { value: "REMOTE", label: "Remote" },
                            { value: "HOME_AUTOMATION", label: "Home Automation" }
                        ],
                        default: "",
                        required: false,
                        affectsPrice: true,
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ],
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue } = helpers

                            // Clear vendor when motorized type changes
                            if (values?.hardware?.vendor) {
                                await setValue("hardware.vendor", undefined)
                            }
                            console.log("FEtch called in motorizied typeLALALALALLALAALL")

                            // Refetch vendors
                            await fetchHardwareVendorHelper(
                                {
                                    ...values,
                                    hardware: {
                                        hardwareType: "MOTORIZED",
                                        motorizedType: newValue
                                    }
                                },
                                helpers
                            )
                        }
                    },
                    {
                        slug: "vendor",
                        name: "Vendor",
                        type: "select",
                        structure: "flat",
                        path: "hardware.vendor",
                        required: true,
                        affectsPrice: true,
                        options: [],
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MANUAL"
                            },
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

export const rollerBlindFeatureGroup = [
    {
        name: "Quantity",
        features: [
            {
                slug: "quantity",
                name: "Quantity",
                type: "number",
                structure: "flat",
                renderType: "quantity",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                default: 1
            }
        ]
    },
    {
        name: "Measurement",
        features: [
            {
                slug: "unit",
                name: "Unit",
                type: "radio",
                structure: "flat",
                required: true,
                affectsPrice: false,
                options: [
                    { value: "cm", label: "Centimeters", default: false },
                    { value: "inch", label: "Inches", default: true }
                ],
                dependencies: []
            },
            {
                slug: "dimensions",
                name: "Width X Height",
                type: "nested",
                structure: "nested",
                renderType: "dimension",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "width",
                        path: "dimensions.width",
                        name: "Width",
                        type: "number",
                        affectsPrice: true,
                        default: 80,
                        required: true
                    },
                    {
                        slug: "height",
                        path: "dimensions.height",
                        name: "Height",
                        type: "number",
                        affectsPrice: true,
                        default: 80,
                        required: true
                    }
                ]
            }
        ]
    },
    {
        name: "Module",
        features: [
            {
                slug: "module",
                name: "Module",
                type: "select",
                required: true,
                affectsPrice: true,
                options: [
                    { value: true, label: "With Module", default: true },
                    { value: false, label: "Without Module", default: false }
                ],
                dependencies: []
            }
        ]
    },
    {
        name: "Facia & Cassette",
        features: [
            {
                slug: "facia",
                name: "Facia",
                type: "select",
                required: true,
                affectsPrice: true,
                options: [
                    { value: true, label: "With Facia", default: true },
                    { value: false, label: "Without Facia", default: false }
                ],
                dependencies: []
            },
            {
                slug: "cassette",
                name: "Cassete",
                type: "select",
                required: true,
                affectsPrice: true,
                options: [
                    { value: true, label: "With Cassette", default: false },
                    { value: false, label: "Without Cassette", default: true }
                ],
                dependencies: [],
                uiConfig: {
                    component: "RadioGroup",
                    groupLabel: "Side Cassette"
                }
            }
        ]
    },
    {
        name: "Hardware",
        features: [
            {
                slug: "hardware",
                name: "Hardware",
                type: "nested",
                structure: "nested",
                // renderType: "HardwareSelector",
                required: true,
                affectsPrice: true,
                options: [],
                dependencies: [],
                features: [
                    {
                        slug: "hardwareType",
                        name: "Hardware Type",
                        type: "select",
                        structure: "flat",
                        path: "hardware.hardwareType",
                        options: [
                            { value: "MOTORIZED", label: "Motorized" },
                            { value: "MANUAL", label: "Manual" },
                            { value: "NONE", label: "No Hardware" }
                        ],
                        required: true,
                        default: "NONE",
                        affectsPrice: true,
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue, handleFeatureChange } = helpers

                            try {
                                const updates = []

                                // Clear vendor
                                if (values?.hardware?.vendor) {
                                    updates.push({ path: "hardware.vendor", value: undefined })
                                }

                                // Handle motorized type
                                if (newValue === "MOTORIZED") {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: "HOME_AUTOMATION"
                                    })
                                } else if (
                                    newValue !== "MOTORIZED" &&
                                    values?.hardware?.motorizedType
                                ) {
                                    updates.push({
                                        path: "hardware.motorizedType",
                                        value: undefined
                                    })
                                }

                                // Apply all updates at once
                                if (updates.length > 0) {
                                    await helpers.setValues(updates)
                                }

                                // Fetch vendors after updates
                                await fetchHardwareVendorHelper(
                                    {
                                        ...values,
                                        hardware: { ...values.hardware, hardwareType: newValue }
                                    },
                                    helpers
                                )
                            } catch (error) {
                                console.error("Error in hardware type onChange:", error)
                            }
                        }
                    },
                    {
                        slug: "motorizedType",
                        name: "Motorized Option",
                        type: "select",
                        structure: "flat",
                        path: "hardware.motorizedType",
                        options: [
                            { value: "REMOTE", label: "Remote" },
                            { value: "HOME_AUTOMATION", label: "Home Automation" }
                        ],
                        default: "HOME_AUTOMATION",
                        required: false,
                        affectsPrice: true,
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ],
                        onFeatureChange: async (newValue, values, helpers) => {
                            const { setValue } = helpers

                            // Clear vendor when motorized type changes
                            if (values?.hardware?.vendor) {
                                await setValue("hardware.vendor", undefined)
                            }
                            console.log("FEtch called in motorizied typeLALALALALLALAALL")

                            // Refetch vendors
                            await fetchHardwareVendorHelper(
                                {
                                    ...values,
                                    hardware: {
                                        hardwareType: "MOTORIZED",
                                        motorizedType: newValue
                                    }
                                },
                                helpers
                            )
                        }
                    },
                    {
                        slug: "vendor",
                        name: "Vendor",
                        type: "select",
                        structure: "flat",
                        path: "hardware.vendor",
                        required: true,
                        affectsPrice: true,
                        options: [],
                        dependencies: [
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MANUAL"
                            },
                            {
                                featureSlug: "hardware.hardwareType",
                                condition: "MOTORIZED"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

export const getFeaturesByProductType = productType => {
    const featuresMap = {
        SOLID_CURTAIN: solidCurtainFeatureGroup,
        SHEER_CURTAIN: sheerCurtainFeatureGroup,
        SOLID_ROMAN_BLIND: solidRomanBlindFeatureGroups,
        SHEER_ROMAN_BLIND: sheerRomanBlindFeatureGroups,
        ROLLER_BLIND: rollerBlindFeatureGroup
    }
    return featuresMap[productType] || []
}

export const getDefaultValuesFromFeatures = featureGroups => {
    const defaults = {}

    const processFeature = feature => {
        // Handle features with direct default property
        if (feature.default !== undefined) {
            defaults[feature.slug] = feature.default
        }
        // Handle nested features with fields
        else if (feature.type === "nested" && feature?.features) {
            const nestedDefaults = {}

            // Check if any fields have defaults
            feature?.features.forEach(field => {
                if (field.default !== undefined) {
                    nestedDefaults[field.slug] = field.default
                }
                // Handle select fields with default option
                else if (field.type === "select" && field.options) {
                    const defaultOption = field.options.find(opt => opt.default)
                    if (defaultOption) {
                        nestedDefaults[field.slug] = defaultOption.value
                    }
                }
            })

            // Only add if there are nested defaults
            if (Object.keys(nestedDefaults).length > 0) {
                defaults[feature.slug] = nestedDefaults
            }
        }
        // Handle regular features with default options
        else if (feature.options) {
            const defaultOption = feature.options.find(opt => opt.default)
            if (defaultOption) {
                defaults[feature.slug] = defaultOption.value
            }
        }
    }

    console.log("Feature Groups: ", featureGroups);

    // Flatten the grouped features
    featureGroups.forEach(group => {
        group.features.forEach(processFeature)
    })

    return defaults
}
